import React, { useState } from 'react';

export default function CtaFooterSection() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  // Waitlist Submit Handler (API Request using relative path)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch('/api/waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setMessage('🎉 Successfully joined the waitlist!');
        setEmail('');
      } else {
        setMessage(data.message || 'Something went wrong.');
      }
    } catch (error) {
      console.error(error);
      setMessage('Server error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-8 pb-16 mb-8">
      <section className="px-6 max-w-6xl mx-auto">
        <div 
          onMouseMove={handleMouseMove}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="relative overflow-hidden bg-[#0B2239] text-white rounded-3xl p-10 md:p-14 text-center space-y-6 shadow-2xl border border-slate-800 transition-all duration-300"
        >
          <div 
            className="pointer-events-none absolute inset-0 transition-opacity duration-300"
            style={{
              opacity: isHovered ? 1 : 0,
              background: `radial-gradient(500px circle at ${mousePos.x}px ${mousePos.y}px, rgba(37, 99, 235, 0.35), rgba(22, 50, 91, 0.15) 40%, transparent 80%)`,
            }}
          />

          <div className="relative z-10 space-y-6 max-w-2xl mx-auto">
            <h2 className="font-serif-title text-3xl sm:text-4xl font-bold tracking-tight">
              One decision. <span className="text-[#60A5FA] italic font-normal">Every market.</span>
            </h2>

            <p className="text-gray-300 text-xs sm:text-sm leading-relaxed">
              Waitlist members get early access and early-bird pricing, 48 hours before public enrollment. No spam — one email when doors open.
            </p>

            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row justify-center items-center gap-3 max-w-md mx-auto pt-2">
              <input 
                type="email" 
                placeholder="you@email.com" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#0A2540]/80 border border-slate-700/80 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-400 focus:outline-none focus:border-[#3B82F6] transition"
                required
              />
              <button 
                type="submit" 
                disabled={loading}
                className="w-full sm:w-auto bg-[#16325B] hover:bg-[#1D4ED8] text-white font-bold px-6 py-3 rounded-xl transition text-sm shrink-0 shadow-lg shadow-[#16325B]/40 border border-blue-400/20 disabled:opacity-50"
              >
                {loading ? 'Submitting...' : 'Join Waitlist'}
              </button>
            </form>

            {message && (
              <p className="text-xs font-bold text-[#60A5FA] pt-2">{message}</p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}